import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import GameScreen from './components/GameScreen';
import MenuScreen from './components/MenuScreen';
import LeaderboardScreen from './components/LeaderboardScreen';
import SettingsScreen from './components/SettingsScreen';
import AchievementsScreen from './components/AchievementsScreen';
import './App.css';

function App() {
  const [currentScreen, setCurrentScreen] = useState('menu');
  const [gameSettings, setGameSettings] = useState({
    difficulty: 'medium',
    gameMode: 'timed'
  });

  const screenVariants = {
    enter: { opacity: 0, y: 20 },
    center: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 }
  };

  const renderScreen = () => {
    switch (currentScreen) {
      case 'game':
        return (
          <GameScreen 
            onBack={() => setCurrentScreen('menu')}
            settings={gameSettings}
          />
        );
      case 'achievements':
        return (
          <AchievementsScreen 
            onBack={() => setCurrentScreen('menu')}
          />
        );
      case 'leaderboard':
        return (
          <LeaderboardScreen 
            onBack={() => setCurrentScreen('menu')}
          />
        );
      case 'settings':
        return (
          <SettingsScreen 
            onBack={() => setCurrentScreen('menu')}
            settings={gameSettings}
            onSettingsChange={setGameSettings}
          />
        );
      default:
        return (
          <MenuScreen 
            onNavigate={setCurrentScreen}
            settings={gameSettings}
          />
        );
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-blue-900 to-indigo-900">
      <AnimatePresence mode="wait">
        <motion.div
          key={currentScreen}
          variants={screenVariants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{ duration: 0.3 }}
          className="min-h-screen"
        >
          {renderScreen()}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

export default App;